import axios from 'axios'

const API_URL = process.env.REACT_APP_API_URL

export type IpiVisFilters = {
  startDate?: string
  endDate?: string
  languages?: string[]
  interpreters?: string[]
  customers?: number[]
}

export type IpiVisScorecards = {
  openAppointments: number
  fulfilmentRate: number
  totalAppointments: number
  completedConfirmed: number
  abandonedCancelled: number
  criticalOpen24h: number
}

export type IpiVisClientRank = {
  rank: number
  customerId: number
  clientName: string
  count: number
  percentage: number
}

export type IpiVisStatusOverTime = {
  label: string
  filled: number
  abandoned: number
  cancelled: number
  open: number
}

export type IpiVisCancellationReason = {
  reason: string
  count: number
  percentage: number
}

export type IpiVisCancellations = {
  cancellationRate: number
  reasons: IpiVisCancellationReason[]
}

export type IpiVisNoShowInterpreter = {
  rank: number
  interpreterId: string
  name: string
  avatarUrl?: string | null
  lastNoShowDate?: string | null
  totalNoShows: number
  noShowRate: number
}

export type IpiVisDashboardData = {
  scorecards: IpiVisScorecards
  topUnfilledClients: IpiVisClientRank[]
  statusOverTime: IpiVisStatusOverTime[]
  isMonthlyBucketed?: boolean
  cancellations: IpiVisCancellations
  topCancelledClients: IpiVisClientRank[]
  topNoShowInterpreters: IpiVisNoShowInterpreter[]
}

export type IpiVisCriticalAppointment = {
  code: number
  recurringId?: number | null
  customerName?: string | null
  startTime: string
  languageTo?: string | null
  status: number
}

export const getIpiVisDashboard = async (filters: IpiVisFilters): Promise<IpiVisDashboardData> => {
  const response = await axios.post(`${API_URL}/Dashboard/ipi-vis/overview`, filters)
  return response.data.data
}

export const getIpiVisCriticalAppointments = async (
  filters: IpiVisFilters
): Promise<IpiVisCriticalAppointment[]> => {
  const response = await axios.post(`${API_URL}/Dashboard/ipi-vis/critical-appointments`, filters)
  return response.data.data
}

export const sendNoShowWarning = async (payload: {
  interpreterId: string
  noShowCount: number
  periodLabel?: string
}): Promise<string> => {
  const response = await axios.post(`${API_URL}/Dashboard/ipi-vis/send-warning`, payload)
  return response.data?.text ?? 'Warning email sent successfully.'
}
